export const DATA_LABEL = 'Cohort';
export const BRUSH_DATA_NAME = 'BRUSH_DATA';
export const BRUSH_DATA_START = 'brush_start';
export const BRUSH_DATA_END = 'brush_end';
